<template>
<!-- 为灵活信号设置页面提供添加信号/账户的下拉页面，根据信号/账户等不同场景展示不同的选项 -->
  <div>
    <Row>
      <Dropdown trigger="click" style="margin-left: 20px" placement="bottom-start" @on-click="this.click" @on-visible-change="this.visible_change">
        <a href="javascript:void(0)">
            {{drop_down_title}}
            <Icon type="ios-arrow-down" v-if="this.icon_flag"></Icon>
        </a>
        <DropdownMenu slot="list">
          <DropdownItem v-for="item in this.dropdown_item" :key="item.name" :name="item.index">{{ item.name }}</DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </Row>
  </div>
</template>
<script>
export default {
  name: "flexible_render_dropdown_view",
  data() {
    return {
      m_allow_msg:{},
      dropdown_item:[]
    }
  },
  props: {
    allow_msg:{
      type: Object,
      default:{}
    },
    m_type: {
      type: String,
      default: ""
    },
    open_or_close: {
      type: String,
      default: ""
    },
    drop_down_title:{
      type: String,
      default: "添加"
    },
    icon_flag: {
      type:Boolean,
      default: true
    }
  },
  methods:{
    make_allow_msg_to_dropdown_view: function() {
      // 对allow_msg进行一定的处理，投递给dropdown_view显示
      let m_allow_msg = JSON.parse(JSON.stringify(this.allow_msg))
      //在account_msg时,需要剔除掉已经在create_or_alter_table_msg中的账户
      //在account_msg时,需要提供一键添加所有账户的选项
      var new_account_msg = m_allow_msg["account_msg"]
      for (var i = 0; i < new_account_msg.length; i++) {
        new_account_msg[i][1] = new_account_msg[i][0] + "号--" + new_account_msg[i][1]
      }
      new_account_msg.unshift(["all", "全部添加"])
      return m_allow_msg
    },
    visible_change(value) {
      if (value === true) {
        this.dropdown_item = this.get_v_for_index()
      }
    },
    click(index) {
      let name = ""
      let description = ""
      let paras = []
      if (this.m_type === 'sign') {
        var msg = this.m_allow_msg[this.m_type][index]
        name = msg[0]
        paras = msg[1]
        description = msg[2]
      } else if (this.m_type === 'default') {
        var msg = this.m_allow_msg[this.m_type][index]
        name = msg[0]
        paras = msg[1]
        description = msg[2]
      } else if (this.m_type === 'account_msg') {
        var msg = this.m_allow_msg[this.m_type][index]
        name = ""
        paras = [msg[0], 1]
        description = msg[1]
      } else if (this.m_type === 'strategy_msg') {
        name = ""
        paras = [index]
        description = ""
      } else {
        console.log("wrong m_type")
      }
      this.$emit("dropdown_click", {
        "m_type":this.m_type,
        "name":name,
        "paras":paras,
        "description":description,
        "open_or_close":this.open_or_close,
        "mode":"ok",
      })
    },
    get_v_for_index() {
      let v_for_index = []
      if (this.allow_msg === null || this.m_type === "") {
        v_for_index.push({"name":""})
        return v_for_index
      } else if (this.m_type === 'strategy_msg') {
        this.m_allow_msg = JSON.parse(JSON.stringify(this.allow_msg))

        for (var key in this.m_allow_msg) {
          if (key.toString() === "-1") {
            continue
          }
          var current_status_code = ""
          for (var i = 0; i < this.m_allow_msg[key].length; i++) {
            if (this.m_allow_msg[key][i]['type'] === 'strategy_msg') {
                //var strategy_name = this.m_allow_msg[key][i]['paras']["name"]
                current_status_code = this.m_allow_msg[key][i]['paras']["current_status_code"]
            }
          }
          if (["0", "1", "2"].indexOf(current_status_code.toString()) != -1) {
            v_for_index.push(
              {name: key+"号策略", index:key}
            )
          }
        }
        return v_for_index
      } else {
        this.m_allow_msg = this.make_allow_msg_to_dropdown_view()
        if (this.m_type === 'sign') {
          for (var i = 0; i < this.m_allow_msg[this.m_type].length; i++) {
            v_for_index.push(
              {name: this.m_allow_msg[this.m_type][i][2], index:i}
            )
          }
        } else if (this.m_type === 'default') {
          for (var i = 0; i < this.m_allow_msg[this.m_type].length; i++) {
            v_for_index.push(
              {name: this.m_allow_msg[this.m_type][i][2], index:i}
            )
          }
        } else if (this.m_type === 'account_msg') {
          for (var i = 0; i < this.m_allow_msg[this.m_type].length; i++) {
            v_for_index.push(
              {name: this.m_allow_msg[this.m_type][i][1], index:i}
            )
          }
        }
        return v_for_index
      }
    }
  },
  mounted: function() {
  },
  watch: {
    
  }
}
</script>
<style>
.demo {
  font-size: 10px;
  border: 0px none transparent;
  background-color:transparent;
}
</style>